import { ContratoService } from './../../../../services/contratos/contrato.service';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { DocumentosService } from 'src/app/pages/services/documentos.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';
@Component({
  selector: 'app-mostrar-contratos',
  templateUrl: './mostrar-contratos.component.html',
  styleUrls: ['./mostrar-contratos.component.css'],
  providers: [DatePipe]
})
export class MostrarContratosComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';
  @Input() idTrabajador: any
  constructor(
    private contraroService: ContratoService,
    private documentoService: DocumentosService,
    private datePipe: DatePipe,
    private alert: AlertHelper,
  ) { }
  displayedColumns = [
    'id',
    'tipo',
    'firma',
    'desde',
    'hasta',
    'acciones'
  ];
  dataSource: any;
  contratos: any;
  info_documento: any;
  loading: boolean = false;
  loadingData: boolean = false;

  ngOnInit(): void {
    this.TraerContratos();
  }

  Descargar(id: any) {
    webPreferences: {
      webSecurity: false
    }
    this.contraroService.traerArchivoContrato(id).subscribe(
      (res) => {
        console.log(res);
        this.info_documento = res.data[0];
        console.log(this.info_documento);
        window.open(`${environment.API}/contratos/` + res.data[0].ruta);
      }

    );
  }


  Borrar(id: number, estado: boolean) {
    if (!confirm('¿Seguro que desea eliminar el contrato?')) return;
    if (estado) {
      this.documentoService.eliminarDocumento(id, 'CONTRATO').subscribe((res: RequestResponse) => {
        this.contraroService.eliminarContrato(id).subscribe((res: RequestResponse) => {
          this.alert.success_small('Se elimino el contrato');
          this.TraerContratos();
        }, (error) => {
          this.alert.error_small('Hubo un error al eliminar el contrato.');
          console.error(error);
        });
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el documento.');
        console.error(error);
      });
    } else {
      this.contraroService.eliminarContrato(id).subscribe((res: RequestResponse) => {
        this.alert.success_small('Se elimino el contrato');
        this.TraerContratos();
      }, (error) => {
        this.alert.error_small('Hubo un error al eliminar el contrato.');
        console.error(error);
      });
    }
  }

  TraerContratos() {
    this.contraroService.traerPorIdTrabajador(this.idTrabajador).subscribe(
      (res) => {
        this.loadingData = true;
        this.contratos = res.data;
        this.dataSource = this.contratos;
        for (let i = 0; i < this.contratos.length; i++) {
          this.contratos[i].fechaFirma = this.datePipe.transform(this.contratos[i].fechaFirma, 'dd-MM-yyyy');
          this.contratos[i].fechaInicio = this.datePipe.transform(this.contratos[i].fechaInicio, 'dd-MM-yyyy');
          this.contratos[i].fechaTermino = this.datePipe.transform(this.contratos[i].fechaTermino, 'dd-MM-yyyy');
          switch (this.contratos[i].tipo_contrato) {
            case 1:
              this.contratos[i].tipo_contrato = 'Contrato';
              break;
            case 2:
              this.contratos[i].tipo_contrato = 'Anexo';
              break;
            case 3:
              this.contratos[i].tipo_contrato = 'Anexo de Remuneración';
              break;
            default:
              this.contratos[i].tipo_contrato = 'Sin definir';
              break;
          }
        }
        this.loadingData = false;
      }
    );
  }

  obtenerTipoContrato(tipo_contrato: number) {
    const tipos = {
      1: 'Contrato',
      2: 'Anexo',
      3: 'Anexo de Remuneración'
    }
    return tipos[tipo_contrato];
  }
}
